const AboutPresentation = () => {
  return (
    <section className="mt-12 px-4 sm:px-8 lg:px-16">
      <h2 className="text-center text-2xl font-extrabold text-gray-900 dark:text-white">
        Présentation
      </h2>
      <div className="mt-6 space-y-6 text-justify leading-relaxed text-gray-700 dark:text-gray-300">
        <p>
          <span className="font-bold">Les Concernés</span> est un magazine
          guinéen à vocation sous-régionale, voir continentale. Créé par un
          groupe d’amis qui ont en commun une passion et un amour
          inconditionnels pour la Guinée et l’Afrique, ce magazine se veut un
          média innovant et disruptif.
        </p>

        <p>
          Face à la pauvreté de l’information entretenue par un certain
          journalisme coopté, qui de plus en plus sacrifie l’objectivité et
          l’intégrité intellectuelles sur l’autel des jeux de connivence,{" "}
          <span className="font-bold">Les Concernés</span> entend en finir avec
          la tyrannie du sensationnel en faisant de la nuance, de l’impartialité
          et de la contradiction intelligente et constructive les forces
          motrices de sa ligne éditoriale.
        </p>

        <p>
          Contre le journalisme de ragots et d’accointances compromettantes,
          celui-là même qui aujourd’hui relègue bon nombre de journalistes au
          rang d’employés de bureau dont le rôle principal serait de
          retranscrire des « scoops » venant de la sphère politique et du monde
          du business, <span className="font-bold">Les Concernés</span> aspire à
          être un média intellectuel qui combine le reportage et la réflexion. À
          notre sens, le journalisme ne devrait pas se limiter à dire
          l’évènement, mais aussi à l’analyser et à contextualiser.
        </p>

        <p>
          Pour les journalistes et autres intellectuels africains en
          particulier, l’un des principaux défis à relever aujourd’hui est
          l’urgence de bien comprendre et de faire cerner les enjeux complexes
          qui se jouent sur le continent. Pour relever ce défi, il faut cultiver
          la nuance, aller au-delà des certitudes, c’est-à-dire remettre en
          question les idées reçues.
        </p>

        <p>
          Ainsi, en plus de dire ou de raconter l’évènement,{" "}
          <span className="font-bold">Les Concernés</span> compte le penser.
          Passionnément attaché à l’excellence et à la rigueur analytique, à la
          liberté d’expression et à l’indépendance éditoriale, ce magazine est
          un projet alternatif – donc citoyen – dont l’ultime objectif est de
          s’inscrire dans « la longue durée », de réactualiser et de pérenniser
          l’héritage de tant d’illustres compatriotes qui se sont distingués par
          leur engagement intellectuel pour la Guinée.
        </p>
      </div>
    </section>
  );
};

export default AboutPresentation;
